module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Blackthorn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("John Blackthorn is the pseudonym of a political figure whose name is known in international capitals and intelligence circles. He has extensive experience in international politics—especially U.S., Russian, and Cuban relations—as well as an insider's knowledge of intelligence methods and operations.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rYmp7m/tc-custom/9780061979774.jpg?1737364746501",
      "alt": "This image is the cover for the book I, Che Guevara"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("I, Che Guevara\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In Cuba, Castro has finally relinquished power. . . . now a mysterious exile (Che Guevara?) returns to finish the revolution.")]), _c('p', [_vm._v("When a strange man appears in rural towns around Cuba quietly advocating a new kind of politics he calls \"the True Republic,\" old-timers begin to suspect that the elderly stranger, who calls himself Ernesto Blanco, may actually be the martyr Ernesto \"Che\" Guevara. Shortly after Blanco's appearance, Fidel Castro steps down from power in exchange for a commitment from the United States to recognize Cuba and lift the crippling embargo. Two traditional parties quickly form: one is a successor to the Communist Party and the other is composed of U.S. and Mafia-backed Cuban exiles. As the True Republic movement spreads like wildfire throughout Cuba, each faction devises a plot to get rid of Ernesto Blanco—by assassination if necessary.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0